import { Box } from "@mui/material"
import SnackBarMessage from "../../components/SnackBarMessage"
import { Header, ActivationForm } from "./components"


const Invite = () => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", px: { lg: 20, md: 10, xs: 5 } }}>
            <Header />
            <ActivationForm />
            <SnackBarMessage />
        </Box>
    )
}

export default Invite